export default __webpack_public_path__ + "static/media/trash.d4f3fc5b.svg";